import { gql } from "urql";
export const UpdatePublicPriorityReferralMutation = gql `
    mutation UpdatePublicPriorityReferral(
        $input: PublicPriorityReferralUpdateInput!
    ) {
        priorityReferrals {
            updatePriorityReferral(input: $input) {
                success
            }
        }
    }
`;
